// TODO: Move these events to libs/users/events/ once the users domain is scaffolded.
// The visit-bridge is a temporary home — the "active patient" concept is owned by the users domain.
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

export const visitBridgePageEvents = eventGroup({
  source: 'VisitBridge',
  events: {
    activePatientRequested: type<void>(),
    activePatientLoaded: type<{ patientId: number }>(),
  },
});
